import { login, logout, getUserInfo, loginbytoken } from '@/api/account'
import _ from 'lodash'

const user = {
  state: {
    account: '',
    nickName: '',
    accountId: '',
    tenantName: ''
  },

  mutations: {
    SET_ACCOUNT: (state, info) => {
      state.account = info
    },
    SET_NICKNAME: (state, info) => {
      state.nickName = info
    },
    SET_ACCOUNT_ID: (state, info) => {
      state.accountId = info
    },
    SET_TENANTNAME: (state, info) => {
      state.tenantName = info
    }
  },

  actions: {
    // 登录
    Login ({ commit, state }, userParams) {
      const {
        tenantCode,
        account,
        password,
        code
      } = userParams
      return new Promise((resolve, reject) => {
        login(tenantCode, account, password, code).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 授权登陆,管理后台携带token跳转到商家中心
    Loginbytoken ({ commit, state }, data) {
      const { access_token } = data
      return new Promise((resolve, reject) => {
        loginbytoken(access_token).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve) => {
        getUserInfo().then(response => {
          commit('SET_ACCOUNT', _.get(response, 'data.account', ''))
          commit('SET_NICKNAME', _.get(response, 'data.nickname', ''))
          commit('SET_ACCOUNT_ID', _.get(response, 'data.admin_id', ''))
          commit('SET_TENANTNAME', _.get(response, 'data.tenant_name', ''))
          resolve(response)
        }).catch(error => {
          resolve(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  }
}

export default user
